import { useEffect, useMemo, useState } from 'react';
import { adminApi } from '@formosa/shared/api/admin';
import UserAgreementEditModal from './UserAgreementEditModal';
import { hasStaticContentBody, mergeStaticContentWithLanguages } from './userAgreementConstants';

function BodyPreview({ detail }) {
  if (!hasStaticContentBody(detail)) {
    return <div className="static-content-card__empty">暫未設置</div>;
  }
  return (
    <div
      className="static-content-card__html"
      dangerouslySetInnerHTML={{ __html: detail.body }}
    />
  );
}

export default function UserAgreementPage() {
  const [records, setRecords] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [editOpen, setEditOpen] = useState(false);

  const mergedDetails = useMemo(
    () => mergeStaticContentWithLanguages(languages, records),
    [languages, records]
  );

  async function loadData() {
    setLoading(true);
    setError('');
    try {
      const [langList, agreementList] = await Promise.all([
        adminApi.newsLanguages(),
        adminApi.getAgreement(),
      ]);
      setLanguages(Array.isArray(langList) ? langList : []);
      setRecords(Array.isArray(agreementList) ? agreementList : []);
    } catch (err) {
      setError(err.message || '載入失敗');
      setRecords([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadData();
  }, []);

  function handleSaved() {
    setMessage('修改成功');
    setEditOpen(false);
    loadData();
  }

  return (
    <div className="page-card">
      <div className="section-header">
        <h2>用戶協議</h2>
        <div className="section-header__actions">
          <button type="button" className="btn btn-success" onClick={() => setEditOpen(true)}>
            修改
          </button>
        </div>
      </div>

      {message ? <p className="form-message form-message--success">{message}</p> : null}
      {error ? <p className="form-message form-message--error">{error}</p> : null}

      {loading ? (
        <p className="table-empty">載入中…</p>
      ) : (
        <div className="static-content-view">
          <h3 className="static-content-view__section-title">內容</h3>
          <div className="static-content-grid">
            {mergedDetails.map((detail) => (
              <article key={detail.lang} className="static-content-card">
                <header className="static-content-card__header">{detail._label || detail.lang}</header>
                <BodyPreview detail={detail} />
              </article>
            ))}
          </div>
        </div>
      )}

      <UserAgreementEditModal
        open={editOpen}
        initialRecords={records}
        languages={languages}
        onClose={() => setEditOpen(false)}
        onSaved={handleSaved}
      />
    </div>
  );
}
